import React, { useCallback } from 'react';
import { trimStart } from 'lodash';
import { SearchInput } from '../../../../../common/components/SearchInput/SearchInput';
import Spinner from '../../../../../common/components/Spinner';
import './SlideoutSearch.scss';

type SlideoutSearchProps = {
  onChange: (value: string) => any;
  value: string;
  placeholder: string;
  rigthContent?: JSX.Element;
};
const SlideoutSearch = ({
  placeholder,
  value,
  onChange,
  rigthContent,
}: SlideoutSearchProps) => {
  const onSearch = useCallback(e => onChange(trimStart(e.target.value)), []);

  return (
    <div className="slideout-search">
      <div className="slideout-search__wr">
        <SearchInput
          placeholder={placeholder || 'Search'}
          className="slideout-search__input"
          value={value}
          onChange={onSearch}
          hasBorder={false}
          inputClassName="slideout-search__search-input"
        />
        <div className="slideout-search__right">{rigthContent}</div>
      </div>
      <Spinner
        show={false}
        position="absolute"
        backgroundColor="none"
        size={30}
      />
    </div>
  );
};

export { SlideoutSearch };
